/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { toast } from "@/shadcnComponents/ui/use-toast";
import { useGeneralSettings } from "@/Providers/General";
import { useAuth } from "@/Providers/Auth";
import { usePayment } from "@/Providers/Payment";
import { useBrand } from "@/Providers/Brand";
import { useCoupon } from "@/Providers/Coupon";

export const useBrandPaymentHandler = () => {
  const [, setPaymentProcessing] = useState(false);
  const generalState = useGeneralSettings();
  const authState = useAuth();
  const paymentState = usePayment();
  const brandState = useBrand();
  const couponState = useCoupon();
  const [Brand, SetBrand] = useState<any>();

  useEffect(() => {
    async function getBrand() {
      const result = await brandState?.getBrandInfo();
      if (result?.success) {
        SetBrand(result?.data1);
      } else {
        toast({
          title: result?.error,
          variant: "destructive",
        });
      }
    }

    getBrand();
  }, []);

  const handleCouponCodeSubmit = async ({
    coupon,
    amount,
    planId,
    onSuccess,
  }: {
    coupon: string;
    amount: number;
    planId?: string;
    onSuccess: (any) => void;
  }) => {
    const result = await couponState?.checkAndVerifyCouponCodeForBrands(
      coupon.toUpperCase(),
      amount,
      planId
    );
    if (result?.success) {
      await onSuccess(result);
    } else {
      alert(result?.error);
    }
  };

  const handlePaymentClick = async ({
    paymentInfo,
    Amount,
    subject,
    onSuccess,
    couponName,
    planID,
    gst,
    expireOn,
    collabCharges,
    anchorsCredits,
    collabCredits,
    pg_charges,
    collabId,
  }: {
    paymentInfo: string;
    Amount: number;
    subject: string;
    onSuccess: (result: any) => void;
    couponName?: string;
    planID?: string;
    gst?: number;
    expireOn?: number;
    collabCharges?: number;
    anchorsCredits?: number;
    collabCredits?: number;
    pg_charges?: number;
    collabId?: string;
  }) => {
    setPaymentProcessing(true);
    generalState?.setLoading(true);

    try {
      // if (Amount === 0 || !Amount) {
      //   setPaymentProcessing(false);
      //   generalState?.setLoading(false);
      //   toast({
      //     title: "Please Enter Amount",
      //     variant: "destructive",
      //   });
      //   return;
      // }

      const order = await paymentState?.createBrandEasebuzzOrder(
        paymentInfo,
        Amount,
        Brand?.CompanyName || Brand?.name,
        authState?.loggedBrand?.email,
        subject,
        expireOn,
        Brand?.companyPhoneNumber || "6267941318",
        couponName,
        planID,
        "",
        gst,
        collabCharges,
        anchorsCredits,
        collabCredits,
        pg_charges,
        collabId
      );

      if (Amount > 0) {
        const key = await paymentState?.getEaseBuzz();
        if (!window.EasebuzzCheckout) {
          throw new Error("EasebuzzCheckout is not loaded");
        }
        const easebuzzCheckout = new window.EasebuzzCheckout(key, "prod");

        const options = {
          access_key: order?.paymentData.data,
          onResponse: (response: any) => {
            handlePaymentResponse(
              response,
              order?.order ?? "",
              onSuccess,
              planID
            );
          },
          theme: "#000000",
        };

        easebuzzCheckout.initiatePayment(options);
      } else {
        generalState?.setLoading(false);
        const response = { status: "success", net_amount_debit: Amount };
        const result = await paymentState?.updateBrandOrder(
          order?.order,
          response,
          planID || ""
        );
        if (result?.success) {
          toast({
            title: "Order Placed Successfully",
            variant: "default",
          });

          await onSuccess(result);
        } else {
          throw new Error("Some error occurred");
        }
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Error in processing the payment",
        variant: "destructive",
      });
      setPaymentProcessing(false);
      generalState?.setLoading(false);
    }
  };

  const handlePaymentResponse = async (
    response: { status: string },
    orderId: string,
    onSuccess: (result: any) => void,
    planId?: string
  ) => {
    setPaymentProcessing(true);
    generalState?.setLoading(false);

    try {
      switch (response.status) {
        case "userCancelled":
          setPaymentProcessing(false);
          generalState?.setLoading(false);
          toast({ title: "You cancelled the Order!" });
          break;
        case "dropped":
          setPaymentProcessing(false);
          generalState?.setLoading(false);
          toast({ title: "You Dropped the Order!" });
          break;
        case "failure":
          setPaymentProcessing(false);
          generalState?.setLoading(false);
          toast({
            title:
              "Payment Failed, if amount got deducted inform us at info@anchors.in",
          });
          break;
        case "pending":
          setPaymentProcessing(false);
          generalState?.setLoading(false);
          toast({
            title:
              "Payment is still pending, complete the payment to proceed, for issues inform us at info@anchors.in",
          });
          break;
        case "success": {
          setPaymentProcessing(false);
          generalState?.setLoading(false);

          const result = await paymentState?.updateBrandOrder(
            orderId,
            response,
            planId || ""
          );
          if (result?.success) {
            toast({
              title: "Order Placed Successfully",
              variant: "default",
            });

            await onSuccess(result);
          } else {
            throw new Error("Some error occurred");
          }
          break;
        }
        default:
          setPaymentProcessing(false);
          generalState?.setLoading(false);
          toast({
            title:
              "The order is not placed. Try again!!! , in case of issues inform us at info@anchors.in",
          });
          break;
      }
    } catch (error) {
      toast({
        title:
          "The order is not placed. Try again!!! , in case of issues inform us at info@anchors.in",
      });
    }
  };

  return { handlePaymentClick, handleCouponCodeSubmit };
};
